import React from "react";
import userphoto from "../../../images/user.png";
import { Dropdown } from "react-bootstrap";
import LogoutPopup from "../LogoutPopup";

const UserProfile = ({ userData }) => {
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <Dropdown className="header-userprofile">
      <Dropdown.Toggle variant="success" id="dropdown-basic">
        <span className="icon">
          <img src={userphoto} alt="admin" />
        </span>
        <p> {userData?.users[0]?.council_profile?.name}</p>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <div className="userprofile-header">
          <div className="icon">
            <img src={userphoto} alt="admin" />
          </div>
          <div className="user-info">
            <p className="user-name">
              {userData?.users[0]?.council_profile?.name}
            </p>
            <p className="user-role-name">Council</p>
          </div>
        </div>
        <Dropdown.Item href="/council-profile">
          {/* <Link to="/council-profile"> */}
          <span className="user-list-cover">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.2692 5.73333C12.2692 6.95327 11.2668 7.96667 10 7.96667C8.73318 7.96667 7.73077 6.95327 7.73077 5.73333C7.73077 4.5134 8.73318 3.5 10 3.5C11.2668 3.5 12.2692 4.5134 12.2692 5.73333ZM13.7692 5.73333C13.7692 7.7952 12.0817 9.46667 10 9.46667C7.91832 9.46667 6.23077 7.7952 6.23077 5.73333C6.23077 3.67147 7.91832 2 10 2C12.0817 2 13.7692 3.67147 13.7692 5.73333ZM8.46342 12.0333H11.5366C13.6689 12.0333 15.5 13.851 15.5 16.2222C15.5 16.3188 15.4636 16.3929 15.4181 16.4403C15.3735 16.4867 15.33 16.5 15.2927 16.5H4.70732C4.67003 16.5 4.62647 16.4867 4.58194 16.4403C4.5364 16.3929 4.5 16.3188 4.5 16.2222C4.5 13.851 6.33108 12.0333 8.46342 12.0333ZM3 16.2222C3 13.0803 5.44606 10.5333 8.46342 10.5333H11.5366C14.5539 10.5333 17 13.0803 17 16.2222C17 17.2041 16.2356 18 15.2927 18H4.70732C3.76439 18 3 17.2041 3 16.2222Z"
                fill="#989DB2"
              />
            </svg>
            Council Profile
          </span>
          {/* </Link> */}
        </Dropdown.Item>
        <Dropdown.Item href="/settings">
          <span className="user-list-cover">
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.309242 5.37855C-0.427656 6.59012 0.276353 7.84169 1.12525 8.30658L1.29948 8.40169C1.29681 8.47103 1.29503 8.54036 1.29414 8.60703C1.29503 8.6737 1.29681 8.74303 1.29948 8.81236L1.12525 8.90748C0.276353 9.37237 -0.427656 10.6239 0.309242 11.8355L1.29325 13.4515C1.98126 14.5813 3.32172 14.632 4.14129 14.1831L4.29951 14.096C4.49685 14.224 4.70218 14.3431 4.91196 14.4533V14.4835C4.91196 15.5698 5.76975 16.6071 7.01599 16.6071H8.98401C10.2302 16.6071 11.088 15.5698 11.088 14.4835V14.4533C11.2978 14.3431 11.5032 14.224 11.7005 14.096L11.8587 14.1831C12.6783 14.632 14.0187 14.5813 14.7067 13.4515L15.6908 11.8355C16.4277 10.6239 15.7236 9.37237 14.8747 8.90748L14.7005 8.81236C14.7032 8.74303 14.705 8.6737 14.7059 8.60703C14.705 8.54036 14.7032 8.47103 14.7005 8.40169L14.8747 8.30658C15.7236 7.84169 16.4277 6.59012 15.6908 5.37855L14.7067 3.76253C14.0187 2.63274 12.6783 2.58296 11.8587 3.03096L11.7005 3.11807C11.5032 2.99007 11.2978 2.87096 11.088 2.76074V2.73051C11.088 1.64428 10.2302 0.606934 8.98401 0.606934H7.01599C5.76975 0.606934 4.91196 1.64428 4.91196 2.73051V2.76074C4.70218 2.87096 4.49685 2.99007 4.29951 3.11807L4.14129 3.03096C3.32172 2.58296 1.98126 2.63274 1.29325 3.76253L0.309242 5.37855ZM4.46396 5.23454L3.28972 4.59098C3.1155 4.49587 2.90038 4.53854 2.80972 4.68787L1.8257 6.30389C1.73504 6.45323 1.80259 6.65056 1.97682 6.74656L3.21772 7.42568C3.12172 7.80346 3.07016 8.19991 3.07016 8.60703C3.07016 9.01414 3.12172 9.41059 3.21772 9.78838L1.97682 10.4675C1.80259 10.5635 1.73504 10.7608 1.8257 10.9102L2.80972 12.5262C2.90038 12.6755 3.1155 12.7182 3.28972 12.6231L4.46396 11.9795C5.06663 12.5884 5.8302 13.0417 6.68798 13.2738V14.4835C6.68798 14.6747 6.83465 14.8293 7.01599 14.8293H8.98401C9.16535 14.8293 9.31202 14.6747 9.31202 14.4835V13.2738C10.1698 13.0417 10.9334 12.5884 11.536 11.9795L12.7103 12.6231C12.8845 12.7182 13.0996 12.6755 13.1903 12.5262L14.1743 10.9102C14.265 10.7608 14.1974 10.5635 14.0232 10.4675L12.7823 9.78838C12.8783 9.41059 12.9298 9.01414 12.9298 8.60703C12.9298 8.19991 12.8783 7.80346 12.7823 7.42568L14.0232 6.74656C14.1974 6.65056 14.265 6.45323 14.1743 6.30389L13.1903 4.68787C13.0996 4.53854 12.8845 4.49587 12.7103 4.59098L11.536 5.23454C10.9334 4.62565 10.1698 4.17231 9.31202 3.9412V2.73051C9.31202 2.5394 9.16535 2.38473 8.98401 2.38473H7.01599C6.83465 2.38473 6.68798 2.5394 6.68798 2.73051V3.9412C5.8302 4.17231 5.06663 4.62565 4.46396 5.23454ZM7.99654 11.2737C9.46767 11.2737 10.6597 10.0799 10.6597 8.60703C10.6597 7.13412 9.46767 5.94033 7.99654 5.94033C6.52541 5.94033 5.3334 7.13412 5.3334 8.60703C5.3334 10.0799 6.52541 11.2737 7.99654 11.2737ZM9 8.60693C9 9.15893 8.55255 9.60693 8 9.60693C7.44745 9.60693 7 9.15893 7 8.60693C7 8.05493 7.44745 7.60693 8 7.60693C8.55255 7.60693 9 8.05493 9 8.60693Z"
                fill="#989DB2"
              />
            </svg>
            Settings
          </span>
        </Dropdown.Item>
        <Dropdown.Item className="user-logout">
          <span className="user-list-cover">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.36111 3.5C4.13273 3.5 3.9137 3.59072 3.75221 3.75221C3.59072 3.9137 3.5 4.13273 3.5 4.36111V15.6389C3.5 15.8673 3.59072 16.0863 3.75221 16.2478C3.9137 16.4093 4.13273 16.5 4.36111 16.5H7.58333C7.99755 16.5 8.33333 16.8358 8.33333 17.25C8.33333 17.6642 7.99755 18 7.58333 18H4.36111C3.73491 18 3.13435 17.7512 2.69155 17.3084C2.24876 16.8657 2 16.2651 2 15.6389V4.36111C2 3.73491 2.24876 3.13435 2.69155 2.69155C3.13435 2.24876 3.73491 2 4.36111 2H7.58333C7.99755 2 8.33333 2.33579 8.33333 2.75C8.33333 3.16421 7.99755 3.5 7.58333 3.5H4.36111ZM12.6919 5.4419C12.9848 5.14901 13.4597 5.14901 13.7526 5.4419L17.7803 9.46968C17.8597 9.54903 17.9175 9.64175 17.9539 9.74058C17.9765 9.80199 17.9914 9.86718 17.9972 9.93494C18.0065 10.042 17.9928 10.1507 17.9562 10.253C17.9201 10.3542 17.8614 10.4493 17.7803 10.5303L13.7526 14.5581C13.4597 14.851 12.9848 14.851 12.6919 14.5581C12.399 14.2652 12.399 13.7903 12.6919 13.4975L15.4394 10.75H7.58331C7.1691 10.75 6.83331 10.4142 6.83331 10C6.83331 9.58579 7.1691 9.25 7.58331 9.25H15.4393L12.6919 6.50256C12.399 6.20967 12.399 5.73479 12.6919 5.4419Z"
                fill="#8A9099"
              />
            </svg>
            <span onClick={() => setModalShow(true)}>Logout</span>
            <LogoutPopup show={modalShow} onHide={() => setModalShow(false)} />
          </span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
export default UserProfile;
